var $fc2b20ad3e18d428$exports = {};
$fc2b20ad3e18d428$exports = {
    "removeButtonLabel": `Usu\u{144}`,
    "removeDescription": `Naci\u{15B}nij Usu\u{144}, aby usun\u{105}\u{107} znacznik.`
};


export {$fc2b20ad3e18d428$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
